import React, { useState } from "react";
import {
  Button,
  Checkbox,
  Col,
  Flex,
  Form,
  Input,
  Modal,
  Row,
  Space,
  Switch,
  Typography,
} from "antd";
import { EditOutlined, DeleteOutlined, CheckOutlined } from "@ant-design/icons";
import { ProductPlanItem } from "../../../../api/usim/uploads/products/productPlanItem";

const { Title, Text } = Typography;

interface ProductType {
  Id?: string;
  key: string;
  ProductType: string;
  TotalStock: number;
  hasICCI: boolean;
  status?: string;
}

interface PlanDetailModalProps {
  isVisible: boolean;
  onClose: () => void;
  productPlan: ProductPlanItem | null;
 
  onStatusChange: (productPlan: ProductPlanItem) => Promise<void>;
}

export default function PlanDetailModal({
  isVisible,
  onClose,
  productPlan,
  onStatusChange,
}: PlanDetailModalProps) {
 

  return (
    <Modal
      title="Product Plan Details"
      open={isVisible}
      onCancel={onClose}

      width={600}
    >
      {productPlan && (
        <Flex gap={16} vertical>
          {/* Action Buttons */}
          <Row justify="space-between" align="bottom">
          <Title level={4} style={{ margin: 0 }}>
              {productPlan.planName}
            </Title>
            {/* create a toggle switch for the status */}
            <Switch checked={productPlan.status === "ACTIVE"} onChange={() => onStatusChange(productPlan)} />
           
           
          </Row>
          <Flex justify="space-between" align="center">
           
          <div>
              <Title level={5}>Product Details</Title>
              <Col>
                <Row >
                  <Text strong>Product Plan: {productPlan.planName}</Text>
                </Row>
                <Row >
                  <Text strong>Product Type: {productPlan.type}</Text>
                </Row>
                <Row >
                  <Text strong>Description: {productPlan.description}</Text>
                </Row>
                <Row >
                  <Text strong>Status: {productPlan.status}</Text>
                </Row>
              </Col>
            
             
            </div>
          </Flex>
        </Flex>
      )}
    </Modal>
  );
}
